import { render, staticRenderFns } from "./MainFooter.vue?vue&type=template&id=4eceb4f9&"
import script from "./MainFooter.vue?vue&type=script&lang=js&"
export * from "./MainFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MainFooter.vue"
export default component.exports